import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "pt", setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    return localStorage.getItem("gf_lang") || "pt";
  });
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("gf_lang", lang);
      document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
    }
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

/** pick strings from a { pt, en } dictionary based on current lang */
export function useT(dict) {
  const { lang } = useLang();
  return dict[lang] || dict.pt;
}
